import { render, staticRenderFns } from "./modalEditTenantSetup.vue?vue&type=template&id=e1f8e022&"
import script from "./modalEditTenantSetup.vue?vue&type=script&lang=js&"
export * from "./modalEditTenantSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports